.card {
  box-sizing: border-box;
  display: block;
  width: min(100%, 330px);
  margin-top: clamp(24px, 3vw, 44px);
  padding: clamp(20px, 2.2vw, 28px);
  border: 1px solid rgba(22, 0, 4, 0.16);
  border-radius: 8px;
  background-color: #faf9f7;
  text-decoration: none;
}

.card--link {
  cursor: pointer;
  transition:
    border-color 200ms ease,
    transform 200ms ease;

  &:hover {
    border-color: rgba(22, 0, 4, 0.32);
    transform: translateY(-1px);

    .arrow {
      transform: translateX(4px);
    }
  }

  &:focus-visible {
    outline: 2px solid rgba(22, 0, 4, 1);
    outline-offset: 3px;
  }
}

.eyebrow {
  margin: 0;
  color: rgba(22, 0, 4, 0.55);
  font-size: 12px;
  font-family: Red Rose-Medium;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  line-height: 1.2;
}

.status {
  margin: clamp(10px, 1.4vw, 16px) 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.statusText {
  color: rgba(22, 0, 4, 1);
  font-size: clamp(18px, 1.6vw, 22px);
  font-family: Red Rose-SemiBold;
  line-height: 1.2;
}

.arrow {
  flex-shrink: 0;
  color: rgba(22, 0, 4, 1);
  font-size: 18px;
  line-height: 1;
  transition: transform 200ms ease;
}

.leadLabel {
  margin: clamp(14px, 2vw, 20px) 0 0;
  color: rgba(22, 0, 4, 0.55);
  font-size: 12px;
  font-family: PingFang SC-Regular;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.2;
}

.leadValue {
  margin: 4px 0 0;
  color: rgba(22, 0, 4, 1);
  font-size: clamp(15px, 1.2vw, 17px);
  font-family: Red Rose-Regular;
  line-height: 1.3;
}

.description {
  margin: clamp(14px, 2vw, 20px) 0 0;
  color: rgba(22, 0, 4, 0.7);
  font-size: 14px;
  font-family: PingFang SC-Regular;
  line-height: 1.6;
}

@media (max-width: 1023px) {
  .card {
    width: min(100%, 460px);
  }
}

@media (max-width: 767px) {
  .card {
    width: 100%;
  }
}
